module.exports = __webpack_public_path__ + "static/media/butterfly2.baf45d33.svg";